module.exports = __webpack_public_path__ + "static/media/wolf-medical.04aca950.png";